<template>
  <hic-dialog title="患者床位管理" :visible="visible" @open="open" @close="close" width="60rem">
    <el-descriptions :column="6">
      <el-descriptions-item label="姓名" :span="2">{{ hospitalization.patientName }}</el-descriptions-item>
      <el-descriptions-item label="性别">{{ hospitalization.patientGender | dictText("Gender") }}</el-descriptions-item>
      <el-descriptions-item label="年龄">{{ hospitalization.patientAge }}</el-descriptions-item>
      <el-descriptions-item label="诊断" :span="2">{{ hospitalization.diagnosisName }}</el-descriptions-item>
    </el-descriptions>
    <el-row type="flex" justify="space-between" align="middle">
      <el-button v-if="!hideWrap" type="primary" size="small" icon="el-icon-box" @click="addBed" plain round>追加包床</el-button>
      <el-popover placement="bottom" title="" trigger="click">
        <el-row class="center info bottom-pad">
          <b>共 {{ logEngities.items.length }} 条</b>
        </el-row>
        <el-scrollbar style="height: 20rem">
          <el-timeline style="margin-left: -1rem; padding: 0 2rem">
            <el-timeline-item v-for="(log, index) in logEngities.items" :key="index" :timestamp="bedInfo(log)" :type="log.type == '入院' ? 'warning ' : log.type == '调床' ? 'success' : 'danger'">
              <span>{{ log.type }} ：</span> <span>{{ log.startTime | fmtDate }}</span> <span v-if="log.endTime">至 {{ log.endTime | fmtDate }} </span> <span v-else>至 今</span>
            </el-timeline-item>
          </el-timeline>
        </el-scrollbar>
        <el-button slot="reference" type="info" size="small" icon="el-icon-house" round plain> 床位历史</el-button>
      </el-popover>
    </el-row>
    <el-table :data="validBeds" @expand-change="showFee">
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="{ row }">
          <el-button type="primary" size="mini" circle plain icon="el-icon-sort" @click="changeBed(row)" title="切换" />
          <el-popconfirm class="left-pad" title="确定要取消包床吗？" @confirm="cancelBed(row)">
            <el-button slot="reference" type="danger" size="mini" circle plain icon="el-icon-delete" :disabled="row.id == hospitalization.bedId" title="取消" />
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column type="expand" align="center" width="30">
        <template slot-scope="{ row }">
          <el-table :data="row.fees" :show-header="false" show-summary>
            <el-table-column prop="feeType" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.feeType | dictText("FeeType") }}
              </template>
            </el-table-column>
            <el-table-column prop="name">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="price" align="right"></el-table-column>
            <el-table-column prop="unit"></el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="no" label="床位号" align="center" sortable="custom" width="100">
        <template slot-scope="{ row }">
          <b>{{ row.no }}</b>
        </template>
      </el-table-column>
      <el-table-column label="主床" align="center" filter width="60">
        <template slot-scope="{ row }">
          <el-tag v-if="row.id == hospitalization.bedId" type="success" effect="dark" size="mini" hit><i class="el-icon-check" /></el-tag>
          <el-button v-else @click="primaryBed(row)" size="mini" circle icon="el-icon-check" title="设为主床" />
        </template>
      </el-table-column>
      <el-table-column prop="wardCode" label="类型" align="center" filter>
        <template slot-scope="{ row }">
          {{ row.type | dictText("BedType") }}
        </template>
      </el-table-column>
      <el-table-column prop="wardCode" label="病区/科室">
        <template slot-scope="{ row }">
          {{ row.wardCode | dictText("IpWard") }}
          {{ row.deptCode | dictText("Dept") }}
        </template>
      </el-table-column>
      <el-table-column prop="building" label="病房">
        <template slot-scope="{ row }">
          {{ row.building | dictText("Building") }}
          {{ row.floor | dictText("Floor") }}
          {{ row.room | dictText("Room") }}
        </template>
      </el-table-column>
      <el-table-column prop="ifExtra" label="加床" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.ifExtra" type="warning" size="mini" hit>是</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="startTime" label="开始日期" align="center">
        <template slot-scope="{ row }">
          {{ row.startTime | fmtDate }}
        </template>
      </el-table-column>
    </el-table>

    <BedSelector :hospitalization="hospitalization" :visible.sync="meta.bedSelectorShow" @selected="onBedSelected" />
  </hic-dialog>
</template>
<script>
  import { apiFuns } from "sw-hic";
  let api = {
    Bed: {
      ...apiFuns.genStandard("bed", "api/ip", false, true),
      exchange: (id, tgtId) => apiFuns.put(`/api/ip/bed/${id}/exchange/${tgtId}`), // 交换床位
      fee: (id) => apiFuns.get(`/api/ip/bed/${id}/feeStandard`),
      wrap: (id, hospitalizationId) => apiFuns.get(`/api/ip/bed/${id}/wrap/${hospitalizationId}`),
      cancel: (id) => apiFuns.del(`/api/ip/bed/${id}/wrap`),
      primary: (id) => apiFuns.put(`/api/ip/bed/${id}/primary`),
    },
    BedLog: apiFuns.genStandard("bedLog", "/api/ip"),
  };
  export default {
    name: "hic-hospitalization-beds-dialog",
    props: {
      hospitalization: Object,
      visible: Boolean,
      hideWrap: Boolean,
    },
    components: {
      BedSelector: () => import("./dialog-bedSelector.vue"),
    },
    data() {
      return {
        meta: {
          bedSelectorShow: false,
          isAddBed: false,
          loading: false,
        },
        logEngities: { items: [] },
        changingBed: null,
        no: null,
        beds: [],
      };
    },
    computed: {
      validBeds() {
        return this.beds.filter((b) => b.ipNo == this.hospitalization.ipNo && (!this.no || b.no.includes(this.no)));
      },
    },
    methods: {
      open() {
        this.no = null;
        this.page();
      },
      page() {
        this.meta.loading = true;

        api.BedLog.query({ hospitalizationId: this.hospitalization.id, sort: "id", asc: false })
          .then((res) => {
            this.logEngities = res;
            return api.Bed.query({ ids: res.items.map((l) => l.bedId) });
          })
          .then((res) => {
            this.beds = res.items;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
      changeBed(bed) {
        this.meta.isAddBed = false;
        this.changingBed = bed;
        this.meta.bedSelectorShow = true;
      },
      addBed() {
        this.meta.isAddBed = true;
        this.meta.bedSelectorShow = true;
      },
      cancelBed(bed) {
        api.Bed.cancel(bed.id)
          .then((res) => {
            this.page();
          })
          .catch((err) => {
            this.$message.error(err);
          });
      },
      primaryBed(bed) {
        api.Bed.primary(bed.id)
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.hospitalization.bedId = bed.id;
            this.hospitalization.bedNo = bed.no;
          });
      },
      showFee(bed) {
        if (bed.fees) {
          return;
        }
        api.Bed.fee(bed.id).then((res) => {
          bed.fees = res;
        });
      },
      onBedSelected(bed) {
        if (this.meta.isAddBed) {
          if (!bed.selected) {
            // 包床
            api.Bed.wrap(bed.id, this.hospitalization.id)
              .then((res) => {
                this.page();
                this.$set(bed, "selected", true);
                this.$message.success("操作成功");
              })
              .catch((err) => {
                this.$message.error(err);
              });
          } else {
            // 取消包床
            api.Bed.cancel(bed.id)
              .then((res) => {
                this.page();
                this.$set(bed, "selected", false);
                this.$message.success("操作成功");
              })
              .catch((err) => {
                this.$message.error(err);
              });
          }
        } else {
          // 调床
          api.Bed.exchange(this.changingBed.id, bed.id).then((res) => {
            this.page();
            this.meta.bedSelectorShow = false;
          });
        }
      },
      bedInfo(log) {
        if (this.beds) {
          let days = this.$utils.Dt.span(log.startTime, log.endTime || this.$utils.Dt.now(), "d");
          let bed = this.beds.find((i) => i.id == log.bedId);
          if (bed) {
            return `${bed.no} ${this.$utils.Dict.text(bed.type, "BedType")}床 ${days}天`;
          }
        }
        return null;
      },
    },
  };
</script>
